import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import WarningRounded from "@material-ui/icons/WarningRounded";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import { isObjectNotEmpty } from "../../Utils";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import FormBox from "../../component/FormBox/FormBox";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import { Response } from "../../constant/Response";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getProfile, getUserRole, getUserSCRN } from "../../redux/selector";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 15,
    },
    tableCell: {
        height: 10,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
});

function EditStaff() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();

    const [staffEmail, setStaffEmail] = useState("");

    const [staffList, setStaffList] = useState({});
    const [refresh, setRefresh] = useState({});
    const [role, setRole] = useState(null);
    const userRole = useSelector(getUserRole());
    const scrn = useSelector(getUserSCRN());
    const profile = useSelector(getProfile());

    const getRoleWording = (role) => {
        return userRole === "SLA" ? t("staff_NGO." + role) : t("staff." + role);
    };

    useEffect(() => {
        const option = {
            url: `${Config.CONTENT_PATH}/users/staff`,
            method: "POST",
            body: JSON.stringify({ scrn: scrn }),
        };
        dispatch(send("GET_STAFF", option))
            .then((response) => response.json())
            .then((result) => {
                //console.log("result: ", result);
                setStaffList(result);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }, [refresh, scrn]);

    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };
    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function deleteReviewer(item) {
        const option = {
            url: `${Config.CONTENT_PATH}/users/removestaff`,
            method: "PUT",
            body: JSON.stringify(item),
        };
        dispatch(send("REMOVE_STAFF", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        response.json().then((result) => {
                            console.log("result: ", result);
                            setStaffList(result);
                        });
                        break;
                    case Response.expectedError:
                        setIsDelegated(true);
                        break;
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    const [otherOrgStaff, setOtherOrgStaff] = useState(false);
    const [isCurrStaff, setIsCurrStaff] = useState(false);
    const [isDelegated, setIsDelegated] = useState(false);
    const handleConfirm = () => {
        setOtherOrgStaff(false);
        setIsCurrStaff(false);
        setIsDelegated(false);
    };
    function addStaff(staffEmail, role) {
        const newStaff = {
            email: staffEmail,
            role: role,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/users/addstaff`,
            method: "POST",
            body: JSON.stringify(newStaff),
        };
        if (
            isObjectNotEmpty(staffList) &&
            staffList.every((item) => item.email != staffEmail)
        ) {
            dispatch(send("ADD_STAFF", option))
                .then((response) => response.json())
                .then((result) => {
                    //console.log("result: ", result);
                    setStaffList(result);
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                    setOtherOrgStaff(true);
                });
        } else {
            setIsCurrStaff(true);
        }
    }
    //#344 Split the accounts clo / sslo / public and reviewer accounts Begin
    function isSSLOUser(role) {
        return ["SLA", "SH", "S"].includes(role);
    }
    //#344 Split the accounts clo / sslo / public and reviewer accounts End

    const onSubmit = () => {
        staffList.push({ scrn: scrn });
        const option = {
            url: `${Config.CONTENT_PATH}/users/updatestaffrole`,
            method: "POST",
            body: JSON.stringify(staffList),
        };
        dispatch(send("UPDATE_STAFF", option))
            .then((response) => response.json())
            .then((result) => {
                //console.log("result: ", result);
                setStaffList(result);
                setIsSavedOpen(true);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
                setRefresh({});
            });
        setRefresh({});

        //console.log("submitted:" + JSON.stringify(staffList));
    };

    //console.log("StaffList:" + JSON.stringify(staffList));
    const handleRoleChange = (event, staffInterfaceUsername) => {
        let foundIndex = staffList.findIndex(
            (x) => x.interfaceUsername == staffInterfaceUsername
        );
        let tmpStaffList = [...staffList];
        tmpStaffList[foundIndex] = {
            ...tmpStaffList[foundIndex],
            role: event.target.value,
        };
        setStaffList(tmpStaffList);
    };
    const [isEmailInvalid, setIsEmailInvalid] = useState(false);
    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.editStaff")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className="main">
                    <Typography variant="h6" component="h1">
                        <br />
                        {t("common.portal.editCurrentStaff")}
                    </Typography>
                    <Paper></Paper>
                    <TableContainer component={Paper}>
                        <Table
                            // className={classes.table}
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                        >
                            <TableHead>
                                <TableRow>
                                    {!isSSLOUser(userRole) && (
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                                padding: "6px 10px",
                                            }}
                                        >
                                            {t("common.portal.name")}
                                        </TableCell>
                                    )}
                                    <TableCell
                                        align="center"
                                        style={{
                                            fontWeight: "bold",
                                            padding: "6px 10px",
                                        }}
                                    >
                                        {t("common.portal.email")}
                                    </TableCell>
                                    {!isSSLOUser(userRole) && (
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.post")}
                                        </TableCell>
                                    )}
                                    <TableCell
                                        align="center"
                                        style={{
                                            fontWeight: "bold",
                                            padding: "6px 10px",
                                        }}
                                    >
                                        <React.Fragment>
                                            {t("common.portal.role")}
                                            {/*<CustomTooltip
                                                fontSize="small"
                                                title={
                                                    userRole === "SLA" ? (
                                                        <React.Fragment>
                                                            LA represents local
                                                            admin;
                                                            <br />
                                                            H represents head of
                                                            organization/school;
                                                            <br />
                                                            SH represents
                                                            subsidiary head;
                                                            <br />
                                                            Staff represents
                                                            general staff
                                                            <br />
                                                            Dropdown is disabled
                                                            as you are not
                                                            allowed to update
                                                            your own role.
                                                        </React.Fragment>
                                                    ) : userRole === "CLA" ? (
                                                        <React.Fragment>
                                                            LA represents local
                                                            admin;
                                                            <br />
                                                            Principal represents
                                                            principal of
                                                            organization/school;
                                                            <br />
                                                            Supervisor
                                                            represents school
                                                            supervisor;
                                                            <br />
                                                            VP represents vice
                                                            principal;
                                                            <br />
                                                            Staff represents
                                                            general staff
                                                            <br />
                                                            Dropdown is only
                                                            enabled for updating
                                                            roles of staff and
                                                            VP (exluding your
                                                            own role).
                                                        </React.Fragment>
                                                    ) : null
                                                }
                                            />*/}
                                        </React.Fragment>
                                    </TableCell>
                                    {userRole === "SLA" && (
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                                padding: "6px 10px",
                                            }}
                                            component="td"
                                        ></TableCell>
                                    )}
                                </TableRow>
                            </TableHead>

                            <TableBody key={scrn}>
                                {isObjectNotEmpty(staffList) &&
                                staffList != undefined
                                    ? staffList.map((item) => (
                                          <React.Fragment
                                              key={item.interfaceUsername}
                                          >
                                              <TableRow>
                                                  {!isSSLOUser(userRole) && (
                                                      <TableCell align="center">
                                                          {item.name} (
                                                          {
                                                              item.interfaceUsername
                                                          }
                                                          )
                                                      </TableCell>
                                                  )}
                                                  <TableCell align="center">
                                                      <a
                                                          href={`mailto:${item.email}`}
                                                          style={{
                                                              color: "black",
                                                          }}
                                                      >
                                                          {item.email}
                                                      </a>
                                                  </TableCell>
                                                  {!isSSLOUser(userRole) && (
                                                      <TableCell align="center">
                                                          {item.post}
                                                      </TableCell>
                                                  )}

                                                  <TableCell align="center">
                                                      {userRole === "SLA" ? (
                                                          <FormControl id="role">
                                                              <Select
                                                                  displayEmpty
                                                                  value={
                                                                      item.role
                                                                  }
                                                                  disabled={
                                                                      item.interfaceUsername ===
                                                                      profile.interfaceUsername
                                                                  }
                                                                  inputProps={{
                                                                      "aria-labelledby":
                                                                          "role",
                                                                  }}
                                                                  onChange={(
                                                                      event
                                                                  ) =>
                                                                      handleRoleChange(
                                                                          event,
                                                                          item.interfaceUsername
                                                                      )
                                                                  }
                                                                  style={{
                                                                      width: "180px",
                                                                  }}
                                                              >
                                                                  <MenuItem
                                                                      value={
                                                                          null
                                                                      }
                                                                  >
                                                                      {getRoleWording(
                                                                          "Staff"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem value="SH">
                                                                      {getRoleWording(
                                                                          "SH"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem value="H">
                                                                      {getRoleWording(
                                                                          "H"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem value="LA">
                                                                      {getRoleWording(
                                                                          "LA"
                                                                      )}
                                                                  </MenuItem>
                                                              </Select>
                                                          </FormControl>
                                                      ) : userRole === "CLA" ? (
                                                          <FormControl id="role">
                                                              <Select
                                                                  displayEmpty
                                                                  value={
                                                                      item.role
                                                                  }
                                                                  inputProps={{
                                                                      "aria-labelledby":
                                                                          "role",
                                                                  }}
                                                                  disabled={
                                                                      (item.role !==
                                                                          null &&
                                                                          item.role !==
                                                                              "VP") ||
                                                                      item.interfaceUsername ===
                                                                          profile.interfaceUsername
                                                                  }
                                                                  onChange={(
                                                                      event
                                                                  ) =>
                                                                      handleRoleChange(
                                                                          event,
                                                                          item.interfaceUsername
                                                                      )
                                                                  }
                                                                  style={{
                                                                      width: "180px",
                                                                  }}
                                                              >
                                                                  <MenuItem
                                                                      value={
                                                                          null
                                                                      }
                                                                  >
                                                                      {getRoleWording(
                                                                          "Staff"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem value="VP">
                                                                      {getRoleWording(
                                                                          "VP"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem
                                                                      value="P"
                                                                      disabled
                                                                  >
                                                                      {getRoleWording(
                                                                          "Principal"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem
                                                                      value="S"
                                                                      disabled
                                                                  >
                                                                      {getRoleWording(
                                                                          "Supervisor"
                                                                      )}
                                                                  </MenuItem>
                                                                  <MenuItem
                                                                      value="LA"
                                                                      disabled
                                                                  >
                                                                      {getRoleWording(
                                                                          "LA"
                                                                      )}
                                                                  </MenuItem>
                                                              </Select>
                                                          </FormControl>
                                                      ) : null}
                                                  </TableCell>
                                                  {userRole === "SLA" && (
                                                      <TableCell
                                                          style={{
                                                              fontWeight:
                                                                  "bold",
                                                              padding:
                                                                  "6px 10px",
                                                              width: "10px",
                                                          }}
                                                      >
                                                          <IconButton
                                                              onClick={() =>
                                                                  deleteReviewer(
                                                                      item
                                                                  )
                                                              }
                                                              color="primary"
                                                              aria-label="remove"
                                                          >
                                                              <RemoveCircleIcon />
                                                          </IconButton>
                                                      </TableCell>
                                                  )}
                                              </TableRow>
                                          </React.Fragment>
                                      ))
                                    : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {userRole === "SLA" && (
                        <Paper>
                            <br />
                            <Grid container style={{ paddingLeft: "20px" }}>
                                <Grid item xs={7} sm={7} md={8}>
                                    <CustomTextField
                                        label={
                                            <>
                                                <Typography component="span">
                                                    {t(
                                                        "common.portal.typeStaffEmailStart"
                                                    )}
                                                </Typography>
                                                <AddCircleIcon
                                                    style={{
                                                        margin: "0 5px",
                                                        color: "#A74128",
                                                    }}
                                                />
                                                <Typography component="span">
                                                    {t(
                                                        "common.portal.typeStaffEmailEnd"
                                                    )}
                                                </Typography>
                                            </>
                                        }
                                        id="typeStaffEmail"
                                        placeholder={t(
                                            "common.portal.inputStaffEmail"
                                        )}
                                        onChange={(e) =>
                                            setStaffEmail(e.target.value)
                                        }
                                        style={{ width: "100%" }}
                                        displayColon={false}
                                    ></CustomTextField>
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sm={4}
                                    md={3}
                                    style={{
                                        display: "flex",
                                        verticalAlign: "bottom",
                                        alignItems: "end",
                                        paddingBottom: "3px",
                                        paddingLeft: "10px",
                                    }}
                                >
                                    <FormControl id="demo-simple-select-filled-label">
                                        <Select
                                            inputProps={{
                                                "aria-labelledby":
                                                    "demo-simple-select-filled-label",
                                            }}
                                            value={role}
                                            style={{
                                                width: "170px",
                                                textAlign: "center",
                                            }}
                                            onChange={(event) =>
                                                setRole(event.target.value)
                                            }
                                            displayEmpty
                                            label={t("common.portal.role")}
                                        >
                                            <MenuItem value={null}>
                                                {getRoleWording("Staff")}
                                            </MenuItem>
                                            <MenuItem value="SH">
                                                {getRoleWording("SH")}
                                            </MenuItem>
                                            <MenuItem value="H">
                                                {getRoleWording("H")}
                                            </MenuItem>
                                            <MenuItem value="LA">
                                                {getRoleWording("LA")}
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1} sm={1} md={1}>
                                    <IconButton
                                        onClick={() => {
                                            if (
                                                staffEmail != "" &&
                                                staffEmail.includes("@")
                                            ) {
                                                addStaff(staffEmail, role);
                                                setIsEmailInvalid(false);
                                            } else {
                                                setIsEmailInvalid(true);
                                            }
                                        }}
                                        style={{ marginTop: "0.8rem" }}
                                        color="primary"
                                        aria-label="remove"
                                    >
                                        <AddCircleIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            {isEmailInvalid ? (
                                <Box name="errorMsg" display="flex" mt={3}>
                                    <Box>
                                        <WarningRounded color="error" />
                                    </Box>
                                    <Box p={1}>
                                        <Typography
                                            component={"span"}
                                            color="error"
                                        >
                                            {t("common.portal.inputValidEmail")}
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                        </Paper>
                    )}
                    <br />
                    <FormBox>
                        <Box display="flex" justifyContent="flex-end">
                            <Button
                                variant="contained"
                                color="primary"
                                // type="submit"
                                onClick={onSubmit}
                            >
                                {t("common.portal.saveBlock")}
                            </Button>
                        </Box>
                    </FormBox>
                    <br />
                </main>
            </Box>
            {isSavedOpen ? SavedDialog(isSavedOpen) : null}
            <AlertDialog
                formOpen={otherOrgStaff}
                content={t("common.portal.otherStaff")}
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={isCurrStaff}
                content={t("common.portal.alreadyIncludedOrg")}
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={isDelegated}
                content={
                    <div
                        style={{ whiteSpace: "pre-wrap" }}
                        dangerouslySetInnerHTML={{
                            __html: t(
                                `common.portal.cannotRemoveDelegatedUser`
                            ),
                        }}
                    />
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
        </Container>
    );
}
export default EditStaff;
